/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcknowledgeChecklistResponseDto,
  BackfillListProjectionControllerBackfill200,
  ChecklistSummaryControllerGetSummaryParams,
  ChecklistSummaryResponseDto,
  CompleteScheduledQuestionnaireControllerComplete200,
  CompleteScheduledQuestionnaireRequestDto,
  GenerateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnaires200,
  GenerateScheduledQuestionnairesDto,
  GetAnswersResponseDto,
  GetScheduledQuestionnaireResponseDto,
  ListScheduledQuestionnairesControllerListScheduledQuestionnairesParams,
  MarkMissedDeadlinesControllerMarkMissedDeadlines200,
  ScheduledQuestionnaireListResponseDto,
  SubmitAnswerControllerSubmitAnswers201,
  SubmitAnswersRequestDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Mark a scheduled questionnaire as completed
 */
export const completeScheduledQuestionnaireControllerComplete = (
  scheduledQuestionnaireId: string,
  completeScheduledQuestionnaireRequestDto: CompleteScheduledQuestionnaireRequestDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CompleteScheduledQuestionnaireControllerComplete200>({
    url: `/v1/scheduled-questionnaires/${scheduledQuestionnaireId}/complete`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: completeScheduledQuestionnaireRequestDto,
    signal,
  });
};

export const getCompleteScheduledQuestionnaireControllerCompleteMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof completeScheduledQuestionnaireControllerComplete>
      >,
      TError,
      {
        scheduledQuestionnaireId: string;
        data: CompleteScheduledQuestionnaireRequestDto;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof completeScheduledQuestionnaireControllerComplete>
    >,
    TError,
    {
      scheduledQuestionnaireId: string;
      data: CompleteScheduledQuestionnaireRequestDto;
    },
    TContext
  > => {
    const mutationKey = ["completeScheduledQuestionnaireControllerComplete"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof completeScheduledQuestionnaireControllerComplete>
      >,
      {
        scheduledQuestionnaireId: string;
        data: CompleteScheduledQuestionnaireRequestDto;
      }
    > = (props) => {
      const { scheduledQuestionnaireId, data } = props ?? {};

      return completeScheduledQuestionnaireControllerComplete(
        scheduledQuestionnaireId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CompleteScheduledQuestionnaireControllerCompleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof completeScheduledQuestionnaireControllerComplete>>
  >;
export type CompleteScheduledQuestionnaireControllerCompleteMutationBody =
  CompleteScheduledQuestionnaireRequestDto;
export type CompleteScheduledQuestionnaireControllerCompleteMutationError =
  void;

/**
 * @summary Mark a scheduled questionnaire as completed
 */
export const useCompleteScheduledQuestionnaireControllerComplete = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof completeScheduledQuestionnaireControllerComplete>
      >,
      TError,
      {
        scheduledQuestionnaireId: string;
        data: CompleteScheduledQuestionnaireRequestDto;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof completeScheduledQuestionnaireControllerComplete>>,
  TError,
  {
    scheduledQuestionnaireId: string;
    data: CompleteScheduledQuestionnaireRequestDto;
  },
  TContext
> => {
  return useMutation(
    getCompleteScheduledQuestionnaireControllerCompleteMutationOptions(options),
    queryClient,
  );
};
/**
 * Processes all enabled questionnaire configs and generates scheduled instances based on their RRule schedule. Idempotent - will not create duplicates. Can be filtered to specific nursery or config. Intended to be called by GCP Cloud Scheduler daily, but can be triggered manually for testing.
 * @summary Generate scheduled questionnaires from enabled configs
 */
export const generateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnaires =
  (
    generateScheduledQuestionnairesDto: GenerateScheduledQuestionnairesDto,
    signal?: AbortSignal,
  ) => {
    return axiosClient<GenerateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnaires200>(
      {
        url: `/v1/scheduled-questionnaires/generate`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: generateScheduledQuestionnairesDto,
        signal,
      },
    );
  };

export const getGenerateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnairesMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnaires
        >
      >,
      TError,
      { data: GenerateScheduledQuestionnairesDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnaires
      >
    >,
    TError,
    { data: GenerateScheduledQuestionnairesDto },
    TContext
  > => {
    const mutationKey = [
      "generateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnaires",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnaires
        >
      >,
      { data: GenerateScheduledQuestionnairesDto }
    > = (props) => {
      const { data } = props ?? {};

      return generateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnaires(
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GenerateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnairesMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnaires
      >
    >
  >;
export type GenerateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnairesMutationBody =
  GenerateScheduledQuestionnairesDto;
export type GenerateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnairesMutationError =
  void;

/**
 * @summary Generate scheduled questionnaires from enabled configs
 */
export const useGenerateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnaires =
  <TError = void, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof generateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnaires
          >
        >,
        TError,
        { data: GenerateScheduledQuestionnairesDto },
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof generateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnaires
      >
    >,
    TError,
    { data: GenerateScheduledQuestionnairesDto },
    TContext
  > => {
    return useMutation(
      getGenerateScheduledQuestionnairesCommandControllerGenerateScheduledQuestionnairesMutationOptions(
        options,
      ),
      queryClient,
    );
  };
/**
 * One-off, idempotent endpoint to populate the denormalised list-projection columns for existing scheduled questionnaires. Run once after deploying the Checklist Manager migration, before exposing the UI.
 * @summary Backfill the Checklist Manager list projection (platform admin only)
 */
export const backfillListProjectionControllerBackfill = (
  signal?: AbortSignal,
) => {
  return axiosClient<BackfillListProjectionControllerBackfill200>({
    url: `/v1/scheduled-questionnaires/backfill-list-projection`,
    method: "POST",
    signal,
  });
};

export const getBackfillListProjectionControllerBackfillMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backfillListProjectionControllerBackfill>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backfillListProjectionControllerBackfill>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["backfillListProjectionControllerBackfill"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backfillListProjectionControllerBackfill>>,
    void
  > = () => {
    return backfillListProjectionControllerBackfill();
  };

  return { mutationFn, ...mutationOptions };
};

export type BackfillListProjectionControllerBackfillMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof backfillListProjectionControllerBackfill>>
  >;

export type BackfillListProjectionControllerBackfillMutationError = void;

/**
 * @summary Backfill the Checklist Manager list projection (platform admin only)
 */
export const useBackfillListProjectionControllerBackfill = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof backfillListProjectionControllerBackfill>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof backfillListProjectionControllerBackfill>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getBackfillListProjectionControllerBackfillMutationOptions(options),
    queryClient,
  );
};
/**
 * System endpoint called by GCP Cloud Scheduler to check for questionnaires that have passed their deadline and mark them as expired. This will trigger email notifications to nursery managers.
 * @summary Mark expired questionnaires as missed (System Task)
 */
export const markMissedDeadlinesControllerMarkMissedDeadlines = (
  signal?: AbortSignal,
) => {
  return axiosClient<MarkMissedDeadlinesControllerMarkMissedDeadlines200>({
    url: `/v1/scheduled-questionnaires/mark-missed`,
    method: "POST",
    signal,
  });
};

export const getMarkMissedDeadlinesControllerMarkMissedDeadlinesMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof markMissedDeadlinesControllerMarkMissedDeadlines>
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof markMissedDeadlinesControllerMarkMissedDeadlines>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["markMissedDeadlinesControllerMarkMissedDeadlines"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof markMissedDeadlinesControllerMarkMissedDeadlines>
      >,
      void
    > = () => {
      return markMissedDeadlinesControllerMarkMissedDeadlines();
    };

    return { mutationFn, ...mutationOptions };
  };

export type MarkMissedDeadlinesControllerMarkMissedDeadlinesMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof markMissedDeadlinesControllerMarkMissedDeadlines>>
  >;

export type MarkMissedDeadlinesControllerMarkMissedDeadlinesMutationError =
  void;

/**
 * @summary Mark expired questionnaires as missed (System Task)
 */
export const useMarkMissedDeadlinesControllerMarkMissedDeadlines = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof markMissedDeadlinesControllerMarkMissedDeadlines>
      >,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markMissedDeadlinesControllerMarkMissedDeadlines>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getMarkMissedDeadlinesControllerMarkMissedDeadlinesMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Submit answers to a scheduled questionnaire
 */
export const submitAnswerControllerSubmitAnswers = (
  scheduledQuestionnaireId: string,
  submitAnswersRequestDto: SubmitAnswersRequestDto,
  signal?: AbortSignal,
) => {
  return axiosClient<SubmitAnswerControllerSubmitAnswers201>({
    url: `/v1/scheduled-questionnaires/${scheduledQuestionnaireId}/answers`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: submitAnswersRequestDto,
    signal,
  });
};

export const getSubmitAnswerControllerSubmitAnswersMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitAnswerControllerSubmitAnswers>>,
    TError,
    { scheduledQuestionnaireId: string; data: SubmitAnswersRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitAnswerControllerSubmitAnswers>>,
  TError,
  { scheduledQuestionnaireId: string; data: SubmitAnswersRequestDto },
  TContext
> => {
  const mutationKey = ["submitAnswerControllerSubmitAnswers"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitAnswerControllerSubmitAnswers>>,
    { scheduledQuestionnaireId: string; data: SubmitAnswersRequestDto }
  > = (props) => {
    const { scheduledQuestionnaireId, data } = props ?? {};

    return submitAnswerControllerSubmitAnswers(scheduledQuestionnaireId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitAnswerControllerSubmitAnswersMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitAnswerControllerSubmitAnswers>>
>;
export type SubmitAnswerControllerSubmitAnswersMutationBody =
  SubmitAnswersRequestDto;
export type SubmitAnswerControllerSubmitAnswersMutationError = void;

/**
 * @summary Submit answers to a scheduled questionnaire
 */
export const useSubmitAnswerControllerSubmitAnswers = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitAnswerControllerSubmitAnswers>>,
      TError,
      { scheduledQuestionnaireId: string; data: SubmitAnswersRequestDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitAnswerControllerSubmitAnswers>>,
  TError,
  { scheduledQuestionnaireId: string; data: SubmitAnswersRequestDto },
  TContext
> => {
  return useMutation(
    getSubmitAnswerControllerSubmitAnswersMutationOptions(options),
    queryClient,
  );
};
/**
 * Retrieves all answers with user information and attached files (with signed download URLs)
 * @summary Get all answers for a scheduled questionnaire
 */
export const getAnswersControllerGetAnswers = (
  scheduledQuestionnaireId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<GetAnswersResponseDto>({
    url: `/v1/scheduled-questionnaires/${scheduledQuestionnaireId}/answers`,
    method: "GET",
    signal,
  });
};

export const getGetAnswersControllerGetAnswersQueryKey = (
  scheduledQuestionnaireId: string,
) => {
  return [
    `/v1/scheduled-questionnaires/${scheduledQuestionnaireId}/answers`,
  ] as const;
};

export const getGetAnswersControllerGetAnswersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>,
  TError = unknown,
>(
  scheduledQuestionnaireId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAnswersControllerGetAnswersQueryKey(scheduledQuestionnaireId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>
  > = ({ signal }) =>
    getAnswersControllerGetAnswers(scheduledQuestionnaireId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      scheduledQuestionnaireId !== null &&
      scheduledQuestionnaireId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAnswersControllerGetAnswersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>
>;
export type GetAnswersControllerGetAnswersQueryError = unknown;

export function useGetAnswersControllerGetAnswers<
  TData = Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>,
  TError = unknown,
>(
  scheduledQuestionnaireId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>,
          TError,
          Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAnswersControllerGetAnswers<
  TData = Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>,
  TError = unknown,
>(
  scheduledQuestionnaireId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>,
          TError,
          Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAnswersControllerGetAnswers<
  TData = Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>,
  TError = unknown,
>(
  scheduledQuestionnaireId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all answers for a scheduled questionnaire
 */

export function useGetAnswersControllerGetAnswers<
  TData = Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>,
  TError = unknown,
>(
  scheduledQuestionnaireId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnswersControllerGetAnswers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAnswersControllerGetAnswersQueryOptions(
    scheduledQuestionnaireId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Clears every failed check on the checklist at once, removing it from the Failed checks tab and the dashboard. Manager or organisation admin only.
 * @summary Acknowledge a checklist's failed checks
 */
export const acknowledgeChecklistControllerAcknowledge = (
  scheduledQuestionnaireId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<AcknowledgeChecklistResponseDto>({
    url: `/v1/scheduled-questionnaires/${scheduledQuestionnaireId}/acknowledge`,
    method: "POST",
    signal,
  });
};

export const getAcknowledgeChecklistControllerAcknowledgeMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acknowledgeChecklistControllerAcknowledge>>,
    TError,
    { scheduledQuestionnaireId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acknowledgeChecklistControllerAcknowledge>>,
  TError,
  { scheduledQuestionnaireId: string },
  TContext
> => {
  const mutationKey = ["acknowledgeChecklistControllerAcknowledge"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acknowledgeChecklistControllerAcknowledge>>,
    { scheduledQuestionnaireId: string }
  > = (props) => {
    const { scheduledQuestionnaireId } = props ?? {};

    return acknowledgeChecklistControllerAcknowledge(scheduledQuestionnaireId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcknowledgeChecklistControllerAcknowledgeMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof acknowledgeChecklistControllerAcknowledge>>
  >;

export type AcknowledgeChecklistControllerAcknowledgeMutationError = void;

/**
 * @summary Acknowledge a checklist's failed checks
 */
export const useAcknowledgeChecklistControllerAcknowledge = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof acknowledgeChecklistControllerAcknowledge>>,
      TError,
      { scheduledQuestionnaireId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof acknowledgeChecklistControllerAcknowledge>>,
  TError,
  { scheduledQuestionnaireId: string },
  TContext
> => {
  return useMutation(
    getAcknowledgeChecklistControllerAcknowledgeMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary List scheduled questionnaires for a nursery
 */
export const listScheduledQuestionnairesControllerListScheduledQuestionnaires =
  (
    nurseryId: string,
    params?: ListScheduledQuestionnairesControllerListScheduledQuestionnairesParams,
    signal?: AbortSignal,
  ) => {
    return axiosClient<ScheduledQuestionnaireListResponseDto>({
      url: `/v1/nurseries/${nurseryId}/scheduled-questionnaires`,
      method: "GET",
      params,
      signal,
    });
  };

export const getListScheduledQuestionnairesControllerListScheduledQuestionnairesQueryKey =
  (
    nurseryId: string,
    params?: ListScheduledQuestionnairesControllerListScheduledQuestionnairesParams,
  ) => {
    return [
      `/v1/nurseries/${nurseryId}/scheduled-questionnaires`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getListScheduledQuestionnairesControllerListScheduledQuestionnairesQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
      >
    >,
    TError = unknown,
  >(
    nurseryId: string,
    params?: ListScheduledQuestionnairesControllerListScheduledQuestionnairesParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListScheduledQuestionnairesControllerListScheduledQuestionnairesQueryKey(
        nurseryId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
        >
      >
    > = ({ signal }) =>
      listScheduledQuestionnairesControllerListScheduledQuestionnaires(
        nurseryId,
        params,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: nurseryId !== null && nurseryId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ListScheduledQuestionnairesControllerListScheduledQuestionnairesQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
      >
    >
  >;
export type ListScheduledQuestionnairesControllerListScheduledQuestionnairesQueryError =
  unknown;

export function useListScheduledQuestionnairesControllerListScheduledQuestionnaires<
  TData = Awaited<
    ReturnType<
      typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
    >
  >,
  TError = unknown,
>(
  nurseryId: string,
  params:
    | undefined
    | ListScheduledQuestionnairesControllerListScheduledQuestionnairesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListScheduledQuestionnairesControllerListScheduledQuestionnaires<
  TData = Awaited<
    ReturnType<
      typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
    >
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: ListScheduledQuestionnairesControllerListScheduledQuestionnairesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListScheduledQuestionnairesControllerListScheduledQuestionnaires<
  TData = Awaited<
    ReturnType<
      typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
    >
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: ListScheduledQuestionnairesControllerListScheduledQuestionnairesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List scheduled questionnaires for a nursery
 */

export function useListScheduledQuestionnairesControllerListScheduledQuestionnaires<
  TData = Awaited<
    ReturnType<
      typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
    >
  >,
  TError = unknown,
>(
  nurseryId: string,
  params?: ListScheduledQuestionnairesControllerListScheduledQuestionnairesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScheduledQuestionnairesControllerListScheduledQuestionnaires
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListScheduledQuestionnairesControllerListScheduledQuestionnairesQueryOptions(
      nurseryId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Checklist Manager tab badge counts (due soon + failed checks)
 */
export const checklistSummaryControllerGetSummary = (
  nurseryId: string,
  params?: ChecklistSummaryControllerGetSummaryParams,
  signal?: AbortSignal,
) => {
  return axiosClient<ChecklistSummaryResponseDto>({
    url: `/v1/nurseries/${nurseryId}/scheduled-questionnaires/summary`,
    method: "GET",
    params,
    signal,
  });
};

export const getChecklistSummaryControllerGetSummaryQueryKey = (
  nurseryId: string,
  params?: ChecklistSummaryControllerGetSummaryParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/scheduled-questionnaires/summary`,
    ...(params ? [params] : []),
  ] as const;
};

export const getChecklistSummaryControllerGetSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>,
  TError = unknown,
>(
  nurseryId: string,
  params?: ChecklistSummaryControllerGetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getChecklistSummaryControllerGetSummaryQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>
  > = ({ signal }) =>
    checklistSummaryControllerGetSummary(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChecklistSummaryControllerGetSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>
>;
export type ChecklistSummaryControllerGetSummaryQueryError = unknown;

export function useChecklistSummaryControllerGetSummary<
  TData = Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>,
  TError = unknown,
>(
  nurseryId: string,
  params: undefined | ChecklistSummaryControllerGetSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>,
          TError,
          Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChecklistSummaryControllerGetSummary<
  TData = Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>,
  TError = unknown,
>(
  nurseryId: string,
  params?: ChecklistSummaryControllerGetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>,
          TError,
          Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChecklistSummaryControllerGetSummary<
  TData = Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>,
  TError = unknown,
>(
  nurseryId: string,
  params?: ChecklistSummaryControllerGetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Checklist Manager tab badge counts (due soon + failed checks)
 */

export function useChecklistSummaryControllerGetSummary<
  TData = Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>,
  TError = unknown,
>(
  nurseryId: string,
  params?: ChecklistSummaryControllerGetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checklistSummaryControllerGetSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getChecklistSummaryControllerGetSummaryQueryOptions(
    nurseryId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Retrieves a single scheduled questionnaire with its config and template information
 * @summary Get a scheduled questionnaire by ID
 */
export const getScheduledQuestionnaireControllerGetScheduledQuestionnaire = (
  scheduledQuestionnaireId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<GetScheduledQuestionnaireResponseDto>({
    url: `/v1/scheduled-questionnaires/${scheduledQuestionnaireId}`,
    method: "GET",
    signal,
  });
};

export const getGetScheduledQuestionnaireControllerGetScheduledQuestionnaireQueryKey =
  (scheduledQuestionnaireId: string) => {
    return [
      `/v1/scheduled-questionnaires/${scheduledQuestionnaireId}`,
    ] as const;
  };

export const getGetScheduledQuestionnaireControllerGetScheduledQuestionnaireQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
      >
    >,
    TError = unknown,
  >(
    scheduledQuestionnaireId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetScheduledQuestionnaireControllerGetScheduledQuestionnaireQueryKey(
        scheduledQuestionnaireId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
        >
      >
    > = ({ signal }) =>
      getScheduledQuestionnaireControllerGetScheduledQuestionnaire(
        scheduledQuestionnaireId,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled:
        scheduledQuestionnaireId !== null &&
        scheduledQuestionnaireId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetScheduledQuestionnaireControllerGetScheduledQuestionnaireQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
      >
    >
  >;
export type GetScheduledQuestionnaireControllerGetScheduledQuestionnaireQueryError =
  unknown;

export function useGetScheduledQuestionnaireControllerGetScheduledQuestionnaire<
  TData = Awaited<
    ReturnType<
      typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
    >
  >,
  TError = unknown,
>(
  scheduledQuestionnaireId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetScheduledQuestionnaireControllerGetScheduledQuestionnaire<
  TData = Awaited<
    ReturnType<
      typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
    >
  >,
  TError = unknown,
>(
  scheduledQuestionnaireId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetScheduledQuestionnaireControllerGetScheduledQuestionnaire<
  TData = Awaited<
    ReturnType<
      typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
    >
  >,
  TError = unknown,
>(
  scheduledQuestionnaireId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a scheduled questionnaire by ID
 */

export function useGetScheduledQuestionnaireControllerGetScheduledQuestionnaire<
  TData = Awaited<
    ReturnType<
      typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
    >
  >,
  TError = unknown,
>(
  scheduledQuestionnaireId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getScheduledQuestionnaireControllerGetScheduledQuestionnaire
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetScheduledQuestionnaireControllerGetScheduledQuestionnaireQueryOptions(
      scheduledQuestionnaireId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
